import React from 'react'
import { css } from '@emotion/core'
import { useContainerWidth, colors } from '@fs/zion-ui'
import { SOLID, GRADIENT, NONE } from './ComparisonPanelBackgroundTypes'

const getGenderColor = (gender) => {
  let color = '#555555'
  if (gender === 'male') {
    color = colors.blue30
  } else if (gender === 'female') {
    color = colors.red60
  }
  return color
}

export default function ComparisonPanel({ children, gender, background = SOLID }) {
  const atWidth = useContainerWidth()
  let backgroundStyle
  let borderStyle

  if (background === GRADIENT) {
    backgroundStyle = atWidth({
      default: '',
      md: 'background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));',
    })
  } else if (background === SOLID) {
    backgroundStyle = 'background-color: rgba(0, 0, 0, 0.7);'
  } else if (background === NONE) {
    backgroundStyle = ''
  }

  if (background === SOLID || background === GRADIENT) {
    borderStyle = `
    border-radius: ${atWidth({ default: 'none', md: '8px' })};
    border-top: ${atWidth({ default: 'none', md: `8px solid ${getGenderColor(gender)}` })};
    `
  }

  const panelStyle = css`
    width: ${atWidth({ default: '100%', lg: '49vw' })};
    max-width: 900px;
    margin: ${atWidth({ default: '1vw 0', lg: '0 1vw' })};
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: ${atWidth({ default: 'column', md: 'row' })};
    ${backgroundStyle}
    ${borderStyle}
    padding: 10px;
  `
  return <div css={panelStyle}>{children} </div>
}
